import {selectGridConfigState} from "../../../redux/reducers/sharedStateReducer/selectors";

// Сетка зависит только от радиуса, а подсчет дел зовет ее на каждом пересчете.
// Никто из расчетов сетку не меняет — только читает
const gridGeometriesByRadius = new Map();

/**
 * Геометрия поля без рендерера: {hexes} с тем же контрактом, что у HexGridRenderer
 * (ключ `q,r` есть, если ячейка входит в поле). Ее понимают calculateAvailable*Cells,
 * поэтому расчеты ячеек работают и на сервере, где поле не отрисовано.
 * Ячейки строятся по радиусу так же, как в HexGridRenderer.generateHexGrid.
 */
export const getGridGeometry = (state) => {
  const {radius} = selectGridConfigState(state);
  // Запоминаем только числовой радиус: для него сетка — функция значения
  const isCacheableRadius = typeof radius === 'number';
  const cachedGeometry = isCacheableRadius ? gridGeometriesByRadius.get(radius) : null;
  if (cachedGeometry) {
    return cachedGeometry;
  }

  const hexes = {};
  for (let q = -radius; q <= radius; q++) {
    for (let r = -radius; r <= radius; r++) {
      const s = -q - r;
      if (Math.abs(s) <= radius) {
        hexes[`${q},${r}`] = true;
      }
    }
  }

  const geometry = {hexes};
  if (isCacheableRadius) {
    gridGeometriesByRadius.set(radius, geometry);
  }
  return geometry;
};
